import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
  Dispatch,
  SetStateAction,
  useCallback,
} from "react";
import { login } from "./SessionApi";

interface GlobalState {
  user: string | null;
  roles: string | null;
}

interface GlobalFunctions {
  setUser: Dispatch<SetStateAction<string | null>>;
  setRoles: Dispatch<SetStateAction<string | null>>;
}

type GolbalContextType = GlobalState & GlobalFunctions;

const GlobalContext = createContext<GolbalContextType | undefined>(undefined);

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobalContext must be used within a GlobalProvider");
  }
  return context;
};

/////////////////////////////////////////////////
// The global provider component

interface GlobalProviderProps {
  children: ReactNode;
}

export const GlobalProvider: React.FC<GlobalProviderProps> = ({ children }) => {
  const [initialized, setInitialized] = useState<boolean>(false);
  const [authAs, setAuthAs] = useState<string | null>(null);
  const [roles, setRoles] = useState<string | null>(null);

  const checkLogin = useCallback(async () => {
    login().then((response) => {
      setAuthAs(response.user);
      setRoles(response.roles);
    });
  }, []);

  useEffect(() => {
    /*
    if (initialized) {
      storeGlobalStateInLocalMemory({
        user: authAs,
        roles: roles,
      } as GlobalState);
      console.log("Updating global state", authAs, roles);
    } else {
      const storedGlobalState: GlobalState = readGlobalStateFromLogalStorage();
      setAuthAs(storedGlobalState.user);
      setRoles(storedGlobalState.roles);
      setInitialized(true);
    }
      */
    checkLogin();
  }, []);

  return (
    <GlobalContext.Provider
      value={{
        user: authAs,
        setUser: setAuthAs,
        roles: roles,
        setRoles: setRoles,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

function storeGlobalStateInLocalMemory(state: GlobalState) {
  localStorage.setItem("roles", state.roles ?? "");
  localStorage.setItem("user", state.user ?? "");
}

function readGlobalStateFromLogalStorage(): GlobalState {
  return {
    roles: localStorage.getItem("roles"),
    user: localStorage.getItem("user"),
  };
}
